import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { IPalletTypeItem } from '../../../modules/API/Defaults/models/pallets';
import PalletStackIcon from '../../icons/IconLib/PalletStackIcon';

interface Props {
    palletTypes: IPalletTypeItem[];
    value: IPalletTypeItem | null;
    onSelect: (palletType: IPalletTypeItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const PalletTypeSelector: React.FC<Props> = ({
    palletTypes,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    className,
}) => {
    const [t] = useTranslation('selectors');

    return (
        <SearchableSelect<IPalletTypeItem>
            items={palletTypes}
            value={value}
            onSelect={onSelect}
            getKey={(p) => p.Pallete_Type}
            getLabel={(p) => (p.Pallete_Desc ?? '').trim()}
            getSearchText={(p) => `${p.Pallete_Desc ?? ''} ${p.Catalog_Number ?? ''}`}
            placeholder={placeholder ?? t('selectors_palletType_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            leadingIcon={<PalletStackIcon />}
            className={className}
            emptyLabel={t('selectors_palletType_empty')}
        />
    );
};

export default PalletTypeSelector;
